import { render, staticRenderFns } from "./BatchGuidesTab.vue?vue&type=template&id=760a1398"
import script from "./BatchGuidesTab.vue?vue&type=script&lang=js"
export * from "./BatchGuidesTab.vue?vue&type=script&lang=js"
import style0 from "./BatchGuidesTab.vue?vue&type=style&index=0&id=760a1398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports